define('app/config/regions',{
	'FDIC_BOSTON': '1 - Boston',
	'FDIC_NEWYORK': '2 - New York',
	'FDIC_PHILADELPHIA': '3 - Philadelphia',
	'FDIC_CLEVELAND': '4 - Cleveland',
	'FDIC_RICHMOND': '5 - Richmond',
	'FDIC_ATLANTA': '6 - Atlanta',
	'FDIC_CHICAGO': '7 - Chicago',
	'FDIC_STLOUIS': '8 - St. Louis',
	'FDIC_MINNEAPOLIS': '9 - Minneapolis',
	'FDIC_KANSAS_CITY': '10 - Kansas City',
	'FDIC_DALLAS': '11 - Dallas',
	'FDIC_SANFRANCSCO': '12 - San Francisco',
	'NCUA_EASTERN': 'Eastern',
	'NCUA_SOUTHERN': 'Southern',
	'NCUA_WESTERN': 'Western'
});

